
import { AssessmentsActions } from '@/components/admin/assessment/AssessmentsActions';
import { AssessmentsSearch } from '@/components/admin/assessment/AssessmentsSearch';
import { AssessmentsGrid } from '@/components/admin/assessment/AssessmentsGrid';
import { EmptyAssessmentsList } from '@/components/admin/assessment/EmptyAssessmentsList';
import { useAssessments } from '@/hooks/useAssessments';

export default function AssessmentsList() {
  const { 
    assessments, 
    loading, 
    searchTerm,
    setSearchTerm,
    handleArchive,
    handleUnarchive
  } = useAssessments();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-pulse text-primary">Loading assessments...</div>
      </div>
    );
  }
  
  return (
    <div className="space-y-4 sm:space-y-6 max-w-none">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex-1 min-w-0">
          <AssessmentsSearch 
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
          />
        </div>
        <div className="flex-shrink-0">
          <AssessmentsActions />
        </div>
      </div>
      
      {assessments.length === 0 ? (
        <EmptyAssessmentsList searchTerm={searchTerm} />
      ) : (
        <AssessmentsGrid 
          assessments={assessments}
          onArchive={handleArchive}
          onUnarchive={handleUnarchive}
        />
      )}
    </div>
  );
}
